// src/components/Tabs/ProSettings.js
// Pro Features
// Chat Background Images
// Custom Bot Icons
// Custom Toogle Button
// Whitelabelling Chatbot

import React from 'react';
import './ProSettings.css';

function ProSettings({
  emailChatTranscriptsTo,
  setEmailChatTranscriptsTo,
}) {
  return (
    <div className="pro-settings">
      <label>
        Email Chat Transcripts to
        <input
          type="email"
          placeholder="marketing@company.com"
          value={emailChatTranscriptsTo}
          onChange={(e) => setEmailChatTranscriptsTo(e.target.value)}
        />
      </label>
      {/* Add more advanced settings as needed */}
    </div>
  );
}

export default ProSettings;
